module.exports = __webpack_public_path__ + "static/media/toolbox.f9a5af47.svg";